import React from 'react';

import CorporateLeadForm, { LeadTypes } from '@components/Form/CorporateLeadForm';
import IconBriefcase from '@components/Images/Rebranding/IconBriefcase';
import IconEarth from '@components/Images/Rebranding/IconEarth';
import IconHandshake from '@components/Images/Rebranding/IconHandshake';
import { SPONSORSHIPS_EMAIL_ADDRESS } from '@utils/constants';

const PartnersHeader = (): JSX.Element => (
  <header className="flex flex-col items-center px-16 text-center text-black sm:flex-row sm:items-start sm:justify-between sm:gap-32 sm:px-28 sm:text-left md:pr-80 lg:pl-0 lg:pr-28">
    <div className="flex-shrink">
      <h1 className="my-0 max-w-[400px] font-suisse-works text-headline-md sm:text-headline-xl">
        Brand Partnerships
      </h1>
      <p className="mt-8 max-w-[400px] font-suisse-neue text-description-lg sm:text-subheadline-md lg:max-w-[512px]">
        The Information works with companies to reach our subscribers with high-quality messages.
      </p>
      <div className="mt-48 hidden h-64 items-center gap-56 text-grayscale-gray sm:flex lg:mt-64 xl:mt-72">
        <IconEarth className="h-full w-auto" />
        <IconHandshake className="h-56 w-auto text-black" />
        <IconBriefcase className="h-56 w-auto" />
      </div>
    </div>
    <CorporateLeadForm
      getInTouchEmailAddress={SPONSORSHIPS_EMAIL_ADDRESS}
      includeNumberOfUsers={false}
      leadType={LeadTypes.BrandPartnership}
    />
  </header>
);

export default PartnersHeader;
